import React, { useState } from "react";
import moment from "moment";
import { toPng } from "html-to-image";
import { Tooltip } from "primereact/tooltip";
import { useTranslation } from 'react-i18next';

const DownloadCharts = ({ divId, filename }) => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadImage = () => {
    const div = document.getElementById(divId);
    setIsLoading(true);
    toPng(div)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${filename} ${moment().format('YYYY-MM-DD HH-mm-ss')}.png`;
        link.click();
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error generating image:", error);
      });
  };
  const{t}=useTranslation();
  const DOWNLOAD_IMAGE=t("DOWNLOAD_IMAGE")

  return (
    <>
      <Tooltip target=".save-image-target" />
      {isLoading ? (
        <i className="pi pi-spin pi-spinner cursor-wait" />
      ) : (
        <i
          className="pi pi-arrow-circle-down cursor-pointer save-image-target"
          data-pr-tooltip={DOWNLOAD_IMAGE}
          onClick={downloadImage}
        />
      )}
    </>
  );
};

export default DownloadCharts;
